import type { PropsWithChildren } from 'react'

import classes from './styles.module.scss'

type Props = {
  enabled?: boolean
}

export default function OfferTagsWrapper({ children, enabled }: PropsWithChildren<Props>) {
  return enabled ? (
    <div className={classes.border}>
      <div className={classes.contentWrapper}>{children}</div>
    </div>
  ) : (
    children
  )
}
